import { PDFFont } from 'pdf-lib';
import { TriggerFileDownloadProps } from './trigger-ttcc-pdf-download';

type BuildFieldsProps = {
  fileProps: TriggerFileDownloadProps;
  formattedDate: string;
  fontBold: PDFFont;
  helveticaFont: PDFFont;
  emojiFont: PDFFont;
};

export function buildFields({ fileProps, formattedDate, fontBold, helveticaFont, emojiFont }: BuildFieldsProps) {
  const {
    data,
    user,
    name = '',
    technologies = '',
    installedCapacity = '',
    saleOptions = '',
    developmentStatus = '',
    location = null,
    corporateFileTitle = '',
    eoiFileTitle = '',
    fileTitle = '',
  } = fileProps;

  const capitalize = (word: string): string => {
    if (!word) return '';
    return word.charAt(0).toUpperCase() + word.slice(1);
  };

  const safeText = (value: any): string => {
    if (value === null || value === undefined) return 'Information not provided';
    return String(value).trim();
  };

  return [
    {
      text: 'Expression of Interest for',
      x: 50,
      y: 680,
      font: fontBold,
      size: 15,
    },
    { text: `${safeText(name)}`, x: 235, y: 680, font: fontBold, size: 15 },
    { text: `Opportunity Name:`, x: 50, y: 610, font: fontBold, size: 11 },
    { text: `${safeText(name)}`, x: 240, y: 610, font: helveticaFont, size: 11 },
    { text: `Technology:`, x: 50, y: 590, font: fontBold, size: 11 },
    { text: `${safeText(technologies)}`, x: 240, y: 590, font: helveticaFont, size: 11 },
    { text: `Installed Capacity:`, x: 50, y: 570, font: fontBold, size: 11 },
    { text: `${safeText(installedCapacity)}`, x: 240, y: 570, font: helveticaFont, size: 11 },
    { text: `Location:`, x: 50, y: 550, font: fontBold, size: 11 },
    { text: `${safeText(location)}`, x: 240, y: 550, font: helveticaFont, size: 11 },
    { text: `Development Status:`, x: 50, y: 530, font: fontBold, size: 11 },
    { text: `${safeText(developmentStatus)}`, x: 240, y: 530, font: helveticaFont, size: 11 },
    { text: `Deal Type:`, x: 50, y: 510, font: fontBold, size: 11 },
    { text: `${safeText(saleOptions)}`, x: 240, y: 510, font: helveticaFont, size: 11 },
    { text: `Expression of Interest Submission:`, x: 50, y: 470, font: fontBold, size: 11 },
    { text: `${safeText(formattedDate)}`, x: 240, y: 470, font: helveticaFont, size: 11 },
    { text: `Submitting Entity:`, x: 50, y: 450, font: fontBold, size: 11 },
    { text: `${safeText(user.company.name)}`, x: 240, y: 450, font: helveticaFont, size: 11 },
    { text: `Transaction approach`, x: 50, y: 390, font: fontBold, size: 15 },
    { text: `Expression of Interest:`, x: 50, y: 370, font: fontBold, size: 11, lineHeight: 8 },
    { text: `${safeText(data.express_interest)}`, x: 50, font: helveticaFont, size: 11 },
    {
      text: `Additional Documents: EOI, Corporate presentation, LOI, etc`,
      x: 50,
      font: fontBold,
      size: 11,
      lineHeight: 8,
    },
    { text: `${safeText(eoiFileTitle)}`, x: 50, font: helveticaFont, size: 11 },
    { text: `Indicative price range:`, x: 50, font: fontBold, size: 11, lineHeight: 8 },
    { text: `${safeText(data.price_range)}`, x: 50, font: helveticaFont, size: 11, marginAfter: 25 },
    { text: `Prospective Buyer Information`, x: 50, font: fontBold, size: 15, lineHeight: 12 },
    { text: `Your Role in Transaction:`, x: 50, font: fontBold, size: 11, sameLine: true },
    { text: `${safeText(data.buyer_type)}`, x: 240, font: helveticaFont, size: 11 },
    { text: `Final Buyer Description:`, x: 50, font: fontBold, size: 11, lineHeight: 8 },
    { text: `${safeText(data.buyer_comments)}`, x: 50, font: helveticaFont, size: 11 },
    //{ text: `Corporate website:`, x: 50, font: fontBold, size: 11, sameLine: true },
    //{ text: `${safeText(data.buyer_website)}`, x: 240, font: helveticaFont, size: 11 },
    //{ text: `Corporate Presentation:`, x: 50, font: fontBold, size: 11, sameLine: true },
    //{ text: `${safeText(corporateFileTitle)}`, x: 240, font: helveticaFont, size: 11, marginAfter: 25 },
    //{ text: `Additional Information & Documents`, x: 50, font: fontBold, size: 15, lineHeight: 12 },
    //{ text: `Additional Information:`, x: 50, font: fontBold, size: 11, lineHeight: 8 },
    //{ text: `${safeText(data.comments)}`, x: 50, font: helveticaFont, size: 11 },
    //{ text: `Other relevant documents:`, x: 50, font: fontBold, size: 11, sameLine: true },
    //{ text: `${safeText(fileTitle)}`, x: 240, font: helveticaFont, size: 11, marginAfter: 25 },
    { text: `Advisory Services`, x: 50, font: fontBold, size: 15, lineHeight: 12 },
    { text: `Do you need a Legal Advisor?`, x: 50, font: fontBold, size: 11, sameLine: true },
    {
      text: `${safeText(capitalize(data.advisory_service_information.legal_advisors))}`,
      x: 270,
      font: helveticaFont,
      size: 11,
    },
    { text: `Do you need a Financial Advisor?`, x: 50, font: fontBold, size: 11, sameLine: true },
    {
      text: `${safeText(capitalize(data.advisory_service_information.financial_advisors))}`,
      x: 270,
      font: helveticaFont,
      size: 11,
    },
    { text: `Do you need a Technical Advisor?`, x: 50, font: fontBold, size: 11, sameLine: true },
    {
      text: `${safeText(capitalize(data.advisory_service_information.technical_advisors))}`,
      x: 270,
      font: helveticaFont,
      size: 11,
    },
    { text: `Do you need an EPC?`, x: 50, font: fontBold, size: 11, sameLine: true },
    {
      text: `${safeText(capitalize(data.advisory_service_information.epc_service))}`,
      x: 270,
      font: helveticaFont,
      size: 11,
      marginAfter: 25,
    },
    /* { text: `Do you need an O&M or Asset Manager?`, x: 50, font: fontBold, size: 11, sameLine: true },
    {
      text: `${safeText(capitalize(data.advisory_service_information.om_service))}`,
      x: 270,
      font: helveticaFont,
      size: 11,
    },
    { text: `Do you need any other service?`, x: 50, font: fontBold, size: 11, lineHeight: 8 },
    {
      text: `${safeText(safeText(data.advisory_service_information.other))}`,
      x: 50,
      font: helveticaFont,
      size: 11,
      marginAfter: 25,
    }, */
    { text: `Legal Confirmation & Acceptance`, x: 50, font: fontBold, size: 15, lineHeight: 12 },
    { text: '✔', x: 50, size: 11, font: emojiFont, sameLine: true },
    {
      text: `I confirm that I have received the necessary internal approvals to submit this Expression of Interest on behalf of my organization.`,
      x: 65,
      font: helveticaFont,
      size: 11,
    },
    { text: '✔', x: 50, size: 11, font: emojiFont, sameLine: true },
    {
      text: `I confirm that I have read and accepted nTeaser's Terms and Conditions, including the 1% success fee payable upon signing a SPA.`,
      x: 65,
      font: helveticaFont,
      size: 11,
    },
  ];
}
